import React, { useState, useEffect, useRef, useCallback } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

import shoppingCartStyle from "assets/jss/material-kit-pro-react/views/shoppingCartStyle.jsx";
import "assets/scss/carrito.scss";

import Globales from "utils/Globales";
import Cargando from "../Generales/Cargando.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import { Link } from "react-router-dom";
import ModalDomicilio from "./ModalDomicilio.jsx";
import ModalCargando from "../Generales/Modales/ModalCargando.jsx";
import { cartApi } from "api/cart/index.js";
import { discountApi } from "api/discunt/index.js";
// Componentes separados
import ProductList from "./components/ProductList.jsx";
import ShippingAddress from "./components/ShippingAddress.jsx";
import ShippingMethod from "./components/ShippingMethod.jsx";
import PurchaseSummary from "./components/PurchaseSummary.jsx";
import { useUserStore } from "stores/userStore.js";
import { useOrderStore } from "stores/orderStore.js";

///Valor minimo para compra coneckta 22/01/2020
const CompraMinimaConekta = 3;

const ShoppingCartPage = ({ classes }) => {
	const { userState, setUserState, setUser } = useUserStore();
	const {
		orderState,
		setOrderState,
		clearOrder,
		setTotalState,
		selectItem,
		selectAllItems,
		changeQuantityItem,
		calculateTotals,
	} = useOrderStore();

	// Estados principales
	const [TipoUsuario, setTipoUsuario] = useState(userState.Type || "");
	const [ValorIvaSistema, setValorIvaSistema] = useState(0);
	const [SaldoCliente, setSaldoCliente] = useState(0);
	const [SaldoClienteRestante, setSaldoClienteRestante] = useState(0);
	const [AplicarSaldo, setAplicarSaldo] = useState(false);
	const [Tallas, setTallas] = useState([]);
	const [selectedEnabled, setSelectedEnabled] = useState("b");
	const [ListaCostosDeEnvio, setListaCostosDeEnvio] = useState([]);
	const [ListaParaCotizar, setListaParaCotizar] = useState([]);
	const [CodigoPostalDestinatario, setCodigoPostalDestinatario] = useState("");
	const [ListaCarrito, setListaCarrito] = useState([]);
	const [NombreAtributo, setNombreAtributo] = useState(0);
	const [errorCostosDeEnvio, setErrorCostosDeEnvio] = useState("");
	const [cargando, setCargando] = useState(false);
	const [loadingShippingMethods, setLoadingShippingMethods] = useState(false);
	const [PrecioFedex, setPrecioFedex] = useState(0);
	const [PrecioRedpack, setPrecioRedpack] = useState(0);
	const [Domicilios, setDomicilios] = useState([]);
	const [DomicilioSeleccionado, setDomicilioSeleccionado] = useState({});
	const [BotonComprar, setBotonComprar] = useState("Continuar");
	const [PreciosEnvio, setPreciosEnvio] = useState({
		RedpackNormal: 0,
		DiasRedpackNormal: 0,
		RedpackExpress: 0,
		DiasRedpackExpress: 0,
		FedexNormal: 0,
		DiasFedexNormal: 0,
		FedexExpress: 0,
		DiasFedexExpress: 0,
	});
	const [DiasDeEntrega, setDiasDeEntrega] = useState(0);
	const [PrecioEnvio, setPrecioEnvio] = useState(0);
	const [Paqueterias, setPaqueterias] = useState([]);
	const [Paqueteria, setPaqueteria] = useState("");
	const [NombrePaqueteria, setNombrePaqueteria] = useState("");
	const [ServicioPaqueteria, setServicioPaqueteria] = useState("");
	const [PaqueteriaSeleccionada, setPaqueteriaSeleccionada] = useState(null);
	const [NombreUsuario] = useState(userState.Name || "");
	const [Correo] = useState(userState.Email || "");
	const [Telefono] = useState(userState.Phone || "");
	const [idUsuarioTerco] = useState(userState.id || "");
	const [VerCostosEnvio, setVerCostosEnvio] = useState(true);
	const [VerModalDomicilio, setVerModalDomicilio] = useState(false);
	const [VerPreciosDias, setVerPreciosDias] = useState(false);
	const [errorPaqueteria, setErrorPaqueteria] = useState(false);
	const [mensajesValidacion, setMensajesValidacion] = useState([]);
	const [colorNotificacion, setColorNotificacion] = useState("success");
	const [mensaje, setMensaje] = useState("");
	const [br, setBr] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(0); // Para forzar re-render cuando cambien las variables globales
	const [pasoActual, setPasoActual] = useState(1); // 1: Selección de productos y dirección, 2: Selección de método de envío

	// Refs para timeouts
	const shippingInfoTimeoutRef = useRef(null);
	const alertTimeoutRef = useRef(null);

	// Inicialización y limpieza (Mount & Unmount)
	useEffect(() => {
		clearOrder();
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;

		setCargando(true);
		ObtenerTallas();
		obtenerEmpresa();
		// ObtenerDomiciliosUsuario(0) también llama a ObtenerCarrito(), así que no lo llamamos dos veces
		// Solo llamamos ObtenerCarrito() si ObtenerDomiciliosUsuario no lo hace
		ObtenerDomiciliosUsuario(0);
		ObtenerSaldoCliente();

		return () => {
			if (shippingInfoTimeoutRef.current) {
				clearTimeout(shippingInfoTimeoutRef.current);
			}
			if (alertTimeoutRef.current) {
				clearTimeout(alertTimeoutRef.current);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Generar lista para cotizar basada en productos seleccionados
	const GenerarListaParaCotizar = useCallback(() => {
		// Validar que haya dirección seleccionada
		if (!orderState.address || Object.keys(orderState.address).length === 0) {
			setListaParaCotizar([]);
			return;
		}

		// Validar que la dirección tenga CodigoPostal
		if (!orderState.address.CodigoPostal) {
			setListaParaCotizar([]);
			return;
		}

		// Solo incluir productos seleccionados
		const productosSeleccionadosList = orderState.items.filter((producto) =>
			orderState.selectedItems.includes(producto._id)
		);

		var lista = [];
		productosSeleccionadosList.forEach((item) => {
			// Intentar obtener idMateriaPrima y peso de diferentes posibles ubicaciones
			const idMateriaPrima =
				item.idModelo?.idMateriaPrima ||
				item.idMateriaPrima ||
				item.product?.idMateriaPrima ||
				null;

			const peso =
				item.idModelo?.Peso || item.Peso || item.product?.weight || 0;

			const cantidad = item.Cantidad || 1;
			const pesoTotal = peso * cantidad;

			if (idMateriaPrima) {
				lista.push({
					_id: item._id,
					idMateriaPrima: idMateriaPrima,
					Cantidad: cantidad,
					Peso: pesoTotal, // Peso total = peso unitario * cantidad
					CodigoPostalDestinatario: orderState.address.CodigoPostal,
					DomicilioSeleccionado: orderState.address,
				});
			}
		});

		setListaParaCotizar(lista);
	}, [orderState.items, orderState.selectedItems, orderState.address]);

	useEffect(() => {
		if (
			orderState.items.length > 0 &&
			orderState.selectedItems.length > 0 &&
			orderState.address
		) {
			GenerarListaParaCotizar();
		} else {
			// Si no hay productos o dirección, limpiar la lista
			setListaParaCotizar([]);
		}
	}, [
		orderState.items,
		orderState.selectedItems,
		orderState.address,
		GenerarListaParaCotizar,
	]);

	useEffect(() => {
		// Solo limpiar mensajes si todo está correcto en paso 1
		// No ejecutar validación completa al inicio para evitar mensajes prematuros
		if (pasoActual === 1) {
			const tieneDireccion =
				orderState.address && Object.keys(orderState.address).length > 0;
			const tieneProductos = orderState.selectedItems.length > 0;

			// Si todo está correcto, limpiar mensajes
			if (tieneDireccion && tieneProductos) {
				setMensajesValidacion([]);
			}
			// Si falta algo, no mostrar mensajes hasta que el usuario intente continuar
		} else if (pasoActual === 2) {
			// En paso 2, validar cuando cambie la paquetería
			if (Paqueteria) {
				ValidarDatos();
			}
		}
	}, [orderState, Paqueteria, pasoActual]);

	// Funciones de obtención de datos
	const obtenerEmpresa = useCallback(() => {
		fetch(Globales.Url + "Empresa/Empresa", {
			method: "GET",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
			mode: "cors",
		})
			.then((res) => res.json())
			.then((data) => {
				if (!data.error) {
					setTotalState({ percentIVA: parseInt(data.data[0].ValorIVA) });
				}
			});
	});

	const ObtenerSaldoCliente = useCallback(() => {
		fetch(
			Globales.Url + "UsuarioClientes/UsuarioClientes/ObtenerSaldoCliente",
			{
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: Globales.token,
				},
				body: JSON.stringify({
					_id: userState.id,
				}),
			}
		)
			.then((res) => res.json())
			.then((data) => {
				if (!data.error) {
					let saldo = data.data.Saldo || 0;
					setTotalState({
						balanceAvailable: saldo,
						balanceApplied: saldo,
					});
				}
			});
	});

	const ObtenerTallas = useCallback(() => {
		fetch(Globales.Url + "Tallas/ObtenerTallas", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
		})
			.then((res) => res.json())
			.then((data) => {
				if (!data.error) {
					setTallas(data.data);
				}
			});
	});

	// Función para formatear precio
	const CambiarFormatoPrecio = useCallback((precio) => {
		return (
			"$" +
			parseFloat(precio, 10)
				.toFixed(2)
				.replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
				.toString()
		);
	});

	// Función para mostrar notificaciones
	const showNotification = useCallback((Mensaje, Color) => {
		setColorNotificacion(Color);
		setMensaje(Mensaje);
		setBr(true);

		if (alertTimeoutRef.current) {
			clearTimeout(alertTimeoutRef.current);
		}

		alertTimeoutRef.current = setTimeout(() => {
			setBr(false);
		}, 3000);
	});

	// Función para aplicar cupón
	const aplicarCupon = useCallback(async (codigoCupon, montoCompra, cantidadProductos, montoEnvio = 0) => {
		try {
			// Si estamos en el paso 1 y no hay costo de envío, validar primero si es un cupón de envío
			const montoEnvioActual = montoEnvio || orderState.totals.shipping || 0;
			if (pasoActual === 1 && montoEnvioActual === 0) {
				// Intentar validar el cupón para ver si es de envío gratis
				const response = await discountApi.validarCupon({
					codigoCupon: codigoCupon,
					idUsuario: userState.id,
					montoCompra: montoCompra,
					cantidadProductos: cantidadProductos || orderState.totals.itemCount || 0,
					montoEnvio: 0
				});

				// Si el error indica que necesita envío, es un cupón de envío gratis
				if (!response.success && response.message && response.message.includes('requiere un costo de envío')) {
					throw new Error(`El cupón "${codigoCupon}" es para envío gratis. Por favor, continúa al paso de envío para aplicarlo.`);
				}
			}

			// Validar y aplicar el cupón normalmente
			const response = await discountApi.validarCupon({
				codigoCupon: codigoCupon,
				idUsuario: userState.id,
				montoCompra: montoCompra,
				cantidadProductos: cantidadProductos || orderState.totals.itemCount || 0,
				montoEnvio: montoEnvioActual
			});

			if (response.success && response.data) {
				const { cupon, descuentoAplicable } = response.data;
				
				// Actualizar el estado del cupón
				setOrderState({
					cupon: {
						codigo: codigoCupon,
						cuponData: cupon,
						descuentoAplicable: descuentoAplicable,
						aplicado: true
					}
				});

				// Recalcular totales
				calculateTotals();

				showNotification(`Cupón "${codigoCupon}" aplicado correctamente. Descuento: ${CambiarFormatoPrecio(descuentoAplicable)}`, "success");
			} else {
				throw new Error(response.message || "Error al validar el cupón");
			}
		} catch (error) {
			console.error("Error al aplicar cupón:", error);
			throw error;
		}
	}, [userState.id, pasoActual, orderState.totals.shipping, orderState.totals.itemCount, setOrderState, calculateTotals, showNotification, CambiarFormatoPrecio]);

	// Función para cargar reglas automáticas aplicables
	const cargarReglasAutomaticas = useCallback(async (itemsList = null, selectedItemsList = null) => {
		try {
			// Usar los parámetros proporcionados o los del estado actual
			const items = itemsList || orderState.items;
			const selectedItems = selectedItemsList || orderState.selectedItems;

			// Si no hay items seleccionados, limpiar reglas automáticas
			if (!items || items.length === 0 || !selectedItems || selectedItems.length === 0) {
				setOrderState({
					reglasAutomaticas: []
				});
				return;
			}

			// Si hay un cupón manual aplicado, no aplicar reglas automáticas
			if (orderState.cupon?.aplicado) {
				setOrderState({
					reglasAutomaticas: []
				});
				return;
			}

			// Filtrar solo items seleccionados
			const productosSeleccionados = items.filter(item => selectedItems.includes(item._id));

			// Calcular totales
			const cantidadTotal = productosSeleccionados.reduce((sum, item) => sum + (item.Cantidad || 0), 0);
			const montoTotal = productosSeleccionados.reduce((sum, item) => {
				const precio = item.product?.public_price || 0;
				const cantidad = item.Cantidad || 0;
				return sum + (precio * cantidad);
			}, 0);

			// Preparar productos para el payload
			// El ID del producto está en idModelo (que es el _id del AbanicoProducto)
			// idModelo puede ser un ObjectId o un string
			const productos = productosSeleccionados.map(item => {
				// El idModelo es el _id del AbanicoProducto (puede ser variación o master)
				let idProducto = null;
				
				if (item.idModelo) {
					// Si idModelo es un objeto con _id, usar _id. Si es un ObjectId directo, usarlo
					idProducto = item.idModelo._id || item.idModelo;
				} else if (item.product?._id) {
					// Fallback: intentar desde product._id
					idProducto = item.product._id;
				} else if (item.idProducto) {
					// Fallback: usar idProducto si existe
					idProducto = item.idProducto;
				}
				
				// Convertir a string si es necesario
				if (idProducto) {
					idProducto = typeof idProducto === 'string' ? idProducto : idProducto.toString();
				}
				
				return {
					idProducto: idProducto,
					cantidad: item.Cantidad || 0,
					precio: item.product?.public_price || 0
				};
			}).filter(p => p.idProducto); // Filtrar productos sin ID

			// Si no hay productos válidos, limpiar reglas automáticas
			if (productos.length === 0) {
				setOrderState({
					reglasAutomaticas: []
				});
				return;
			}

			// Llamar al API para obtener reglas automáticas
			const response = await discountApi.obtenerReglasAutomaticas({
				idUsuario: userState.id,
				productos: productos,
				montoTotal: montoTotal,
				cantidadTotal: cantidadTotal
			});

			if (response.success && response.data && response.data.reglas && response.data.reglas.length > 0) {
				// Aplicar todas las reglas automáticas aplicables
				setOrderState({
					reglasAutomaticas: response.data.reglas
				});

				// Recalcular totales para aplicar los descuentos
				calculateTotals();
			} else {
				// No hay reglas aplicables
				setOrderState({
					reglasAutomaticas: []
				});

				// Recalcular totales para remover descuentos si había alguno
				calculateTotals();
			}
		} catch (error) {
			console.error("Error al cargar reglas automáticas:", error);
			// En caso de error, limpiar reglas automáticas
			setOrderState({
				reglasAutomaticas: []
			});
		}
	}, [userState.id, orderState.items, orderState.selectedItems, orderState.cupon, setOrderState, calculateTotals]);

	// Recargar reglas automáticas cuando cambien items, cantidades o selección
	// Solo si no hay cupón manual aplicado
	useEffect(() => {
		// Solo recargar si hay items seleccionados y no hay cupón manual
		if (orderState.items.length > 0 && orderState.selectedItems.length > 0 && !orderState.cupon?.aplicado) {
			// Usar debounce para evitar múltiples llamadas
			const timeoutId = setTimeout(() => {
				cargarReglasAutomaticas();
			}, 500); // Esperar 500ms después del último cambio

			return () => clearTimeout(timeoutId);
		} else if (orderState.cupon?.aplicado) {
			// Si hay cupón manual, limpiar reglas automáticas
			setOrderState({
				reglasAutomaticas: []
			});
		}
	}, [orderState.items, orderState.selectedItems, orderState.cupon?.aplicado, orderState.totals.itemCount, orderState.totals.subtotal, cargarReglasAutomaticas, setOrderState]);

	// Función para remover cupón
	const removerCupon = useCallback(() => {
		setOrderState({
			cupon: {
				codigo: null,
				cuponData: null,
				descuentoAplicable: 0,
				aplicado: false
			}
		});

		// Recalcular totales
		calculateTotals();

		// Recargar reglas automáticas después de remover cupón manual
		setTimeout(() => {
			cargarReglasAutomaticas();
		}, 100);

		showNotification("Cupón removido", "info");
	}, [setOrderState, calculateTotals, showNotification, cargarReglasAutomaticas]);

	// Obtener costos de envío
	const ObtenerCostosDeEnvio = useCallback(async () => {
		try {
			setLoadingShippingMethods(true);
			setErrorCostosDeEnvio("");

			if (ListaParaCotizar.length === 0) {
				setErrorCostosDeEnvio("No hay productos para cotizar");
				return;
			}

			// Preparar domicilio (todos los items van al mismo destino)
			const domicilio = {
				province: orderState.address.Estado,
				city: orderState.address.Municipio,
				name: orderState.address.Nombre,
				zip: orderState.address.CodigoPostal,
				address1: orderState.address.Calle,
				address2: orderState.address.Colonia,
				phone: orderState.address.TelefonoReferencia,
			};

			// Consolidar todos los items: agrupar por idMateriaPrima y sumar pesos y cantidades
			const itemsConsolidados = {};
			const itemsPorId = {}; // Para mantener referencia de qué items originales corresponden

			ListaParaCotizar.forEach((paquete) => {
				const idMateriaPrima = paquete.idMateriaPrima;

				if (!itemsConsolidados[idMateriaPrima]) {
					itemsConsolidados[idMateriaPrima] = {
						idMateriaPrima: idMateriaPrima,
						weight: 0,
						quantity: 0,
						itemsIds: [], // IDs de los items originales
					};
					itemsPorId[idMateriaPrima] = [];
				}

				itemsConsolidados[idMateriaPrima].weight += paquete.Peso;
				itemsConsolidados[idMateriaPrima].quantity += paquete.Cantidad;
				itemsConsolidados[idMateriaPrima].itemsIds.push(paquete._id);
				itemsPorId[idMateriaPrima].push(paquete);
			});

			// Si todos los items tienen el mismo idMateriaPrima, hacer una sola petición
			const idsMateriaPrima = Object.keys(itemsConsolidados);

			if (idsMateriaPrima.length === 1) {
				// Todos tienen el mismo material, consolidar en una sola petición
				const itemConsolidado = itemsConsolidados[idsMateriaPrima[0]];

				const data = await cartApi.getCost({
					address: domicilio,
					idmaterial: itemConsolidado.idMateriaPrima,
					weight: itemConsolidado.weight,
					quantity: itemConsolidado.quantity,
				});

				if (data.success && data.data.rates.length) {
					// Guardar también las cajas de envío
					const shippingBoxes = data.data.shipping_boxes || [];
					
					// Asignar los costos a todos los items originales
					const ListaCostosDeEnvio = data.data.rates.map((m) => ({
						// Preservar todos los campos originales del rate primero
						...m,
						// Campos legacy (compatibilidad con código existente) - sobrescriben si existen
						idModelo: itemConsolidado.itemsIds, // Array de IDs de items
						Precio: parseInt(m.amount_local),
						Paqueteria: m.provider,
						Servicio: m.service_level_code,
						Dias: m.days,
						Id: m.id,
						// Campos nuevos de Skydropx (requeridos para crear shipment)
						quotation_id: m.quotation_id || data.data.quotation_id || null,
						rate_id: m.rate_id || m.id || null,
						// Cajas de envío usadas para esta cotización
						shipping_boxes: shippingBoxes,
					}));

					setListaCostosDeEnvio(ListaCostosDeEnvio);
				} else {
					setErrorCostosDeEnvio("No se obtuvieron costos de envío");
				}
			} else {
				// Tienen diferentes materiales, necesitamos consolidar por material
				// pero aún podemos hacer menos peticiones agrupando por idMateriaPrima
				const resultados = await Promise.all(
					idsMateriaPrima.map(async (idMateriaPrima) => {
						const itemConsolidado = itemsConsolidados[idMateriaPrima];

						const data = await cartApi.getCost({
							address: domicilio,
							idmaterial: itemConsolidado.idMateriaPrima,
							weight: itemConsolidado.weight,
							quantity: itemConsolidado.quantity,
						});

						if (data.success && data.data.rates.length) {
							// Guardar también las cajas de envío de este material
							const shippingBoxes = data.data.shipping_boxes || [];
							
							return data.data.rates.map((m) => ({
								// Preservar todos los campos originales del rate primero
								...m,
								// Campos legacy (compatibilidad con código existente) - sobrescriben si existen
								idModelo: itemConsolidado.itemsIds, // Array de IDs
								Precio: parseInt(m.amount_local),
								Paqueteria: m.provider,
								Servicio: m.service_level_code,
								Dias: m.days,
								Id: m.id,
								// Campos nuevos de Skydropx (requeridos para crear shipment)
								quotation_id: m.quotation_id || data.data.quotation_id || null,
								rate_id: m.rate_id || m.id || null,
								// Cajas de envío usadas para esta cotización (de este material)
								shipping_boxes: shippingBoxes,
							}));
						} else {
							return [];
						}
					})
				);

				const ListaCostosDeEnvio = resultados.flat();
				
				// Consolidar todas las cajas de envío únicas de todos los materiales
				const allShippingBoxes = [];
				const boxesMap = new Map();
				ListaCostosDeEnvio.forEach(rate => {
					if (rate.shipping_boxes && Array.isArray(rate.shipping_boxes)) {
						rate.shipping_boxes.forEach(box => {
							// Crear una clave única para evitar duplicados
							const boxKey = `${box.weight}-${box.height}-${box.width}-${box.length}`;
							if (!boxesMap.has(boxKey)) {
								boxesMap.set(boxKey, box);
								allShippingBoxes.push(box);
							}
						});
					}
				});
				
				// Asignar todas las cajas consolidadas a cada rate
				ListaCostosDeEnvio.forEach(rate => {
					rate.shipping_boxes = allShippingBoxes;
				});
				
				if (ListaCostosDeEnvio.length > 0) {
					setListaCostosDeEnvio(ListaCostosDeEnvio);
				} else {
					setErrorCostosDeEnvio("No se obtuvieron costos de envío");
				}
			}
		} catch (error) {
			console.error("Error al obtener costos de envío:", error);
			showNotification(error.message, "danger");
		} finally {
			setLoadingShippingMethods(false);
		}
	}, [ListaParaCotizar, orderState.address, showNotification]);

	useEffect(() => {
		if (pasoActual === 2 && ListaParaCotizar.length > 0 && orderState.address) {
			ObtenerCostosDeEnvio();
		}
		// Solo re-ejecutar al cambiar paso o lista; no incluir ObtenerCostosDeEnvio/orderState.address para evitar ciclo de peticiones
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pasoActual, ListaParaCotizar]);

	// Obtener carrito
	const ObtenerCarrito = useCallback(async () => {
		// Verificar que el usuario esté autenticado antes de obtener el carrito
		if (!userState.id || userState.id === 'null' || userState.id === '') {
			return;
		}
		
		global.Index = 0;
		setListaCostosDeEnvio([]);
		setPaqueterias([]);
		setVerCostosEnvio(true);
		setPasoActual(1); // Resetear al paso 1 al cargar el carrito
		try {
			let respuesta = await cartApi.getCartByUser(userState.id);
			if (!respuesta.success) {
				showNotification(respuesta.message, "danger");
			} else {
				const { data } = respuesta;
				var ListaParaCotizar = [];
				var listaCarritoNew = [];

				setUserState({
					ShoppingCart: respuesta.data,
					Basket: respuesta.data.length,
				});

				respuesta.data.forEach((item) => {
					const precioUnitario = item.product?.public_price || 0;
					const cantidad = item.Cantidad || 1;
					item["PrecioTotal"] = precioUnitario * cantidad;
					listaCarritoNew.push(item);
				});

				// Leer parámetro disenoId de URL o sessionStorage para "Comprar ahora"
				let disenoIdParaComprar = null;
				
				// Intentar leer de URL query parameter (compatibilidad con rutas normales y con hash)
				let searchParams = new URLSearchParams(window.location.search);
				if (searchParams.has("disenoId")) {
					const disenoIdFromUrl = searchParams.get("disenoId");
					// Validar que no sea null, "null", undefined o vacío
					if (disenoIdFromUrl && disenoIdFromUrl !== 'null' && disenoIdFromUrl !== 'undefined' && disenoIdFromUrl.trim() !== '') {
						disenoIdParaComprar = disenoIdFromUrl;
					}
				} else {
					// Si no está en search, intentar desde el hash (para compatibilidad con rutas con #)
					const hash = window.location.hash;
					if (hash && hash.includes("?")) {
						const hashParams = new URLSearchParams(hash.split("?")[1]);
						if (hashParams.has("disenoId")) {
							const disenoIdFromHash = hashParams.get("disenoId");
							// Validar que no sea null, "null", undefined o vacío
							if (disenoIdFromHash && disenoIdFromHash !== 'null' && disenoIdFromHash !== 'undefined' && disenoIdFromHash.trim() !== '') {
								disenoIdParaComprar = disenoIdFromHash;
								searchParams = hashParams; // Usar hashParams para limpiar después
							}
						}
					}
				}
				
				// Si no está en URL, intentar leer de sessionStorage (funciona solo si es el mismo dominio)
				if (!disenoIdParaComprar && typeof sessionStorage !== 'undefined') {
					try {
						const disenoIdFromStorage = sessionStorage.getItem('disenoIdParaComprar');
						if (disenoIdFromStorage && disenoIdFromStorage !== 'null' && disenoIdFromStorage !== 'undefined' && disenoIdFromStorage.trim() !== '') {
							disenoIdParaComprar = disenoIdFromStorage;
							// Limpiar sessionStorage después de leer
							sessionStorage.removeItem('disenoIdParaComprar');
						}
					} catch (e) {
						// Si hay error de sessionStorage (puede pasar en dominios distintos), ignorar silenciosamente
						console.warn('No se pudo acceder a sessionStorage:', e);
					}
				}

				// Determinar qué items seleccionar
				let selectedItems = [];
				if (disenoIdParaComprar) {
					// Solo seleccionar el diseño específico que viene de "Comprar ahora"
					// Buscar el item en el carrito que corresponda a ese diseño
					// El disenoIdParaComprar es el ID del diseño (DisenoProductos._id)
					// Necesitamos encontrar el item del carrito que tiene ese idDiseno
					const itemEncontrado = listaCarritoNew.find(item => {
						// El campo puede ser idDiseno (objeto o string) o desing.id
						const idDisenoItem = item.idDiseno?._id || item.idDiseno || item.desing?.id || item.desing?._id || item.desing;
						return idDisenoItem && String(idDisenoItem) === String(disenoIdParaComprar);
					});
					
					if (itemEncontrado) {
						// Usar el _id del registro del carrito (no el del diseño)
						selectedItems = [itemEncontrado._id];
						
						// Reorganizar la lista para poner el item seleccionado al principio
						const index = listaCarritoNew.indexOf(itemEncontrado);
						if (index > 0) {
							// Remover el item de su posición actual y ponerlo al principio
							listaCarritoNew.splice(index, 1);
							listaCarritoNew.unshift(itemEncontrado);
						}
					} else {
						// Si no se encuentra, seleccionar todos (fallback por seguridad)
						selectedItems = listaCarritoNew.map((producto) => producto._id);
					}
				} else {
					// Comportamiento normal: seleccionar todos
					selectedItems = listaCarritoNew.map((producto) => producto._id);
				}

				setOrderState({
					items: listaCarritoNew,
					selectedItems: selectedItems,
				});

				// Cargar reglas automáticas aplicables después de cargar los items
				// Esperar un momento para que se establezca el estado antes de calcular
				setTimeout(async () => {
					await cargarReglasAutomaticas(listaCarritoNew, selectedItems);
				}, 100);
				
				// Limpiar parámetro de URL DESPUÉS de establecer el estado (con un pequeño delay para asegurar que se procese)
				if (disenoIdParaComprar) {
					setTimeout(() => {
						// Limpiar parámetro de URL si existe en search (para evitar que se mantenga en la URL)
						// Nota: Si está en hash, no lo limpiamos para evitar complicaciones con la navegación
						if (window.location.search && window.location.search.includes("disenoId")) {
							const urlSearchParams = new URLSearchParams(window.location.search);
							if (urlSearchParams.has("disenoId")) {
								urlSearchParams.delete("disenoId");
								const newSearch = urlSearchParams.toString() ? '?' + urlSearchParams.toString() : '';
								const newUrl = window.location.pathname + newSearch + window.location.hash;
								window.history.replaceState({}, '', newUrl);
							}
						}
					}, 100);
				}
				setCargando(false);
			}
		} catch (error) {
			showNotification(error.message, "danger");
		} finally {
			setCargando(false);
		}
	}, [showNotification]);

	// Eliminar producto
	const EliminarProductoCarrito = useCallback(
		(id) => {
			fetch(Globales.Url + "Carrito/Carrito/EliminarProductoCarrito", {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: Globales.token,
				},
				body: JSON.stringify({ _id: id }),
			})
				.then((res) => res.json())
				.then((data) => {
					if (!data.error) {
						setOrderState((prev) =>
							prev.items.filter((productoId) => productoId._id !== id)
						);
						showNotification(data.mensaje, "danger");
						ObtenerCarrito();
					}
				});
		},
		[showNotification, ObtenerCarrito]
	);

	// Validar datos
	const ValidarDatos = useCallback(() => {
		var valido = true;
		const mensajes = [];
		if (orderState.selectedItems.length == 0) {
			valido = false;
			mensajes.push("Debes seleccionar al menos un artículo");
		}

		// Validar dirección solo si realmente no existe
		const tieneDireccion =
			orderState.address && Object.keys(orderState.address).length > 0;

		if (!tieneDireccion) {
			valido = false;
			mensajes.push("Falta dirección de envío");
		}

		// Solo validar paquetería si estamos en el paso 2
		if (pasoActual === 2) {
			if (tieneDireccion) {
				if (Paqueteria === "" || !Paqueteria) {
					valido = false;
					mensajes.push("Selecciona paquetería");
					setErrorPaqueteria(true);
				} else {
					setErrorPaqueteria(false);
				}
			}

			if (DiasDeEntrega === "") {
				valido = false;
			}
			if (PrecioEnvio === "") {
				valido = false;
			}
		}

		// Actualizar mensajes solo si hay errores
		// Si todo está correcto, limpiar mensajes
		if (valido) {
			setMensajesValidacion([]);
		} else {
			setMensajesValidacion(mensajes);
		}

		return valido;
	}, [orderState, Paqueteria, DiasDeEntrega, PrecioEnvio, pasoActual]);

	// Validar formulario completo
	const validarFormularioCompleto = useCallback(() => {
		const tieneProductosSeleccionados = orderState.selectedItems.length > 0;
		const tieneDireccion =
			orderState.address && Object.keys(orderState.address).length > 0;
		const tienePaqueteria =
			Paqueteria !== "" && Paqueteria !== null && VerPreciosDias;

		return tieneProductosSeleccionados && tieneDireccion && tienePaqueteria;
	}, [orderState, Paqueteria, VerPreciosDias]);

	// Cambiar paquetería
	const CambiarPaqueteria = useCallback(
		async (e) => {
			const paqueteriaTemp = e.target.value;

			// Actualizar todos los estados primero
			setPaqueteria(paqueteriaTemp.Paqueteria);
			setVerPreciosDias(true);
			setErrorPaqueteria(false);
			setDiasDeEntrega(paqueteriaTemp.Dias);
			setPrecioEnvio(paqueteriaTemp.Precio);
			setNombrePaqueteria(paqueteriaTemp.Paqueteria);
			setServicioPaqueteria(paqueteriaTemp.Servicio);

			const costoEnvio = paqueteriaTemp.Precio || 0;
			setTotalState({
				shipping: costoEnvio,
			});
			setOrderState({
				shipping: paqueteriaTemp,
			});
		},
		[orderState, userState.id]
	);

	// Obtener domicilios usuario
	const ObtenerDomiciliosUsuario = useCallback(
		(op) => {
			fetch(
				Globales.Url +
					"UsuarioClientes/UsuarioClientes/ObtenerDomicilioPorUsuario",
				{
					method: "POST",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						Authorization: Globales.token,
					},
					body: JSON.stringify({
						_id: userState.id,
					}),
				}
			)
				.then((res) => res.json())
				.then((data) => {
					if (!data.error && data.data.Domicilios !== undefined) {
						if (data.data.Domicilios.length >= 0) {
							var ultimoDomicilio = null;
							data.data.Domicilios.forEach((d) => {
								if (d.Usado === true) {
									ultimoDomicilio = d;
								}
							});
							setDomicilios(data.data.Domicilios);
							setOrderState({
								address: ultimoDomicilio,
							});
							if (op === 0) {
								ObtenerCarrito();
							}
						}
					}
				});
		},
		[ObtenerCarrito]
	);

	// Evento modal domicilio
	const eventoModalDomicilio = useCallback(
		(domicilio, opcion) => {
			if (opcion === "cambio") {
				const domiciliosActualizados = Domicilios.map((m) => {
					if (m._id === domicilio._id) {
						m.Usado = true;
						return m;
					} else {
						m.Usado = false;
						return m;
					}
				});

				setDomicilios(domiciliosActualizados);
				setPaqueteria("");
				setOrderState({
					address: domicilio,
				});
				setVerCostosEnvio(true);
				setVerPreciosDias(false);
				setListaCostosDeEnvio([]);
				setPaqueterias([]);
				setPasoActual(1); // Resetear al paso 1 cuando cambia la dirección
			}

			if (opcion === "nuevo") {
				setPaqueteria("");
				setVerCostosEnvio(true);
				setVerPreciosDias(false);
				setListaCostosDeEnvio([]);
				setPaqueterias([]);
				setPasoActual(1); // Resetear al paso 1 cuando se agrega nueva dirección
				global.Index = 0;
				setTimeout(() => {
					ObtenerDomiciliosUsuario(0);
					// Limpiar mensajes al agregar nueva dirección
					setMensajesValidacion([]);
				}, 0);
			}

			setVerModalDomicilio(false);
		},
		[Domicilios]
	);

	// Confirmar compra
	const ConfirmarCompra = useCallback(() => {
		if (ValidarDatos()) {
			var Productos = [];
			var CostoEnvio = [{ amount: global.Envio, carrier: Paqueteria }];
			var Usuario = {
				name: NombreUsuario,
				email: Correo,
				phone: orderState.address.TelefonoReferencia,
			};
			var Domicilio = {
				address: {
					street1: orderState.address.Calle,
					postal_code: orderState.address.CodigoPostal,
					country: "MX",
				},
			};
			var metodo = [
				{
					payment_method: {
						type: "card",
						token_id: "",
					},
				},
			];

			const productosSeleccionadosList = orderState.items.filter((producto) =>
				orderState.selectedItems.includes(producto._id)
			);

			productosSeleccionadosList.forEach((producto) => {
				const precioUnitario = producto.product?.public_price || 0;
				Productos.push({
					name: `${producto.product?.description || ""} / ${producto.desing
						?.name || ""}`,
					nombre_producto: producto.product?.description || "",
					unit_price: precioUnitario * 100,
					quantity: producto.Cantidad,
					cartId: producto._id,
				});
			});

			if (orderState.shipping) {
				CostoEnvio[0].amount = orderState.shipping.Precio * 100;
				CostoEnvio[0].carrier = orderState.shipping.Paqueteria;
				CostoEnvio[0].days = orderState.shipping.Dias;
			}

			var ArregloFinal = {
				line_items: Productos,
				shipping_lines: CostoEnvio,
				customer_info: Usuario,
				shipping_contact: Domicilio,
				charges: metodo,
				Productos: orderState.items,
				Domicilio: orderState.address,
				Total: global.Total,
				shipping_carrier: {
					...orderState.shipping,
					// Incluir cajas de envío para guardarlas en la compra
					shipping_boxes: orderState.shipping?.shipping_boxes || [],
				},
			};
			setOrderState({ checkoutData: ArregloFinal });

			setBotonComprar("Procesando");
			document.getElementById("ConfirmarCompra").click();
		} else {
			showNotification("Faltan datos por capturar", "warning");
		}
	}, [
		ValidarDatos,
		Paqueteria,
		NombreUsuario,
		Correo,
		orderState,
		showNotification,
	]);

	// Manejar el botón Continuar
	const handleContinuar = useCallback(() => {
		if (pasoActual === 1) {
			// Validar productos y dirección
			if (orderState.selectedItems.length === 0) {
				setMensajesValidacion(["Debes seleccionar al menos un artículo"]);
				return;
			}
			if (!orderState.address || Object.keys(orderState.address).length === 0) {
				setMensajesValidacion(["Falta dirección de envío"]);
				return;
			}
			// Pasar al paso 2
			setPasoActual(2);
			setMensajesValidacion([]);
			// Disparar carga de paqueterías al entrar a paso 2 (evita depender solo del effect por sincronía)
			if (ListaParaCotizar.length > 0 && orderState.address) {
				ObtenerCostosDeEnvio();
			}
		} else {
			// Paso 2: Validar todo y confirmar compra
			ConfirmarCompra();
		}
	}, [pasoActual, orderState, ConfirmarCompra, ListaParaCotizar, ObtenerCostosDeEnvio]);

	// Estilos inline
	const containerFluid = {
		paddingRight: "15px",
		paddingLeft: "15px",
		marginRight: "auto",
		marginLeft: "auto",
		width: "100%",
	};
	const container = {
		...containerFluid,
		"@media (min-width: 576px)": {
			maxWidth: "540px",
		},
		"@media (min-width: 768px)": {
			maxWidth: "720px",
		},
		"@media (min-width: 992px)": {
			maxWidth: "960px",
		},
		"@media (min-width: 1200px)": {
			maxWidth: "1920px",
		},
	};

	return (
		<div>
			<div className="carrito-container">
				<div style={container}>
					<GridContainer
						style={{
							marginTop: "0",
							marginBottom: "20px",
						}}
					>
						<GridItem xs={12}>
							<h2 className="carrito-title">Listos para fabricar</h2>
						</GridItem>
					</GridContainer>
					<GridContainer spacing={3}>
						<GridItem lg={8} md={12} sm={12} xs={12}>
							{cargando === true ? (
								<>
									<Card className="carrito-card">
										<CardBody className="carrito-card-body no-padding">
											<div className="carrito-card-title-section">
												<div className="carrito-select-all-container">
													<div
														className="skeleton-line"
														style={{
															width: "24px",
															height: "24px",
															borderRadius: "4px",
															marginRight: "12px",
														}}
													/>
													<div
														className="skeleton-line"
														style={{
															width: "150px",
															height: "20px",
														}}
													/>
												</div>
												<Divider />
											</div>
											{[1, 2, 3].map((index) => (
												<div
													key={index}
													style={{
														display: "flex",
														padding: "20px",
														borderBottom:
															index < 3 ? "1px solid #e0e0e0" : "none",
													}}
												>
													<div
														className="skeleton-line"
														style={{
															width: "24px",
															height: "24px",
															borderRadius: "4px",
															marginRight: "16px",
															flexShrink: 0,
														}}
													/>
													<div
														className="skeleton-line"
														style={{
															width: "100px",
															height: "100px",
															borderRadius: "8px",
															marginRight: "16px",
															flexShrink: 0,
														}}
													/>
													<div style={{ flex: 1 }}>
														<div
															className="skeleton-line"
															style={{
																width: "60%",
																height: "20px",
																marginBottom: "8px",
															}}
														/>
														<div
															className="skeleton-line"
															style={{
																width: "40%",
																height: "16px",
																marginBottom: "8px",
															}}
														/>
														<div
															className="skeleton-line"
															style={{
																width: "30%",
																height: "16px",
															}}
														/>
													</div>
													<div
														style={{
															display: "flex",
															flexDirection: "column",
															alignItems: "flex-end",
															gap: "12px",
														}}
													>
														<div
															className="skeleton-line"
															style={{
																width: "80px",
																height: "20px",
															}}
														/>
														<div
															style={{
																display: "flex",
																alignItems: "center",
																gap: "8px",
															}}
														>
															<div
																className="skeleton-line"
																style={{
																	width: "30px",
																	height: "30px",
																	borderRadius: "4px",
																}}
															/>
															<div
																className="skeleton-line"
																style={{
																	width: "40px",
																	height: "20px",
																}}
															/>
															<div
																className="skeleton-line"
																style={{
																	width: "30px",
																	height: "30px",
																	borderRadius: "4px",
																}}
															/>
														</div>
													</div>
												</div>
											))}
										</CardBody>
									</Card>
									<Card className="carrito-card">
										<CardBody className="carrito-card-body">
											<div className="carrito-card-title-section">
												<h4 className="carrito-card-title">
													Dirección de envío
												</h4>
												<Divider />
											</div>
											<div style={{ padding: "20px" }}>
												<div
													className="skeleton-line"
													style={{
														width: "100%",
														height: "20px",
														marginBottom: "12px",
													}}
												/>
												<div
													className="skeleton-line"
													style={{
														width: "80%",
														height: "16px",
														marginBottom: "8px",
													}}
												/>
												<div
													className="skeleton-line"
													style={{
														width: "60%",
														height: "16px",
													}}
												/>
											</div>
										</CardBody>
									</Card>
								</>
							) : orderState.items.length > 0 ? (
								<>
									{/* Mostrar listado y dirección solo en el paso 1 */}
									{pasoActual === 1 && (
										<>
											<ProductList
												productos={orderState.items}
												productosSeleccionados={orderState.selectedItems}
												onCheckboxChange={selectItem}
												onSelectAll={selectAllItems}
												onQuantityChange={changeQuantityItem}
												onDelete={EliminarProductoCarrito}
												formatPrice={CambiarFormatoPrecio}
												porcentajesDescuentoPorItem={orderState.porcentajesDescuentoPorItem || {}}
												montosDescuentoPorItem={orderState.montosDescuentoPorItem || {}}
											/>

											<ShippingAddress
												domicilioSeleccionado={orderState.address}
												domicilios={Domicilios}
												onAddNew={() => setVerModalDomicilio(true)}
												onChange={() => setVerModalDomicilio(true)}
											/>
										</>
									)}

									{/* Mostrar método de envío solo en el paso 2 */}
									{pasoActual === 2 && (
										<>
											<Card className="carrito-card">
												<CardBody className="carrito-card-body">
													<div
														style={{
															display: "flex",
															justifyContent: "space-between",
															alignItems: "center",
															marginBottom: "20px",
														}}
													>
														<h4 className="carrito-card-title">
															Método de envío
														</h4>
														<Button
															size="sm"
															color="default"
															onClick={() => {
																setPasoActual(1);
																setListaCostosDeEnvio([]);
																setPaqueteriaSeleccionada(null);
																setPaqueteria("");
																setMensajesValidacion([]);
															}}
														>
															← Volver a productos
														</Button>
													</div>
													<Typography
														variant="body2"
														color="textSecondary"
														style={{ marginBottom: "20px" }}
													>
														Si necesitas cambiar cantidades o productos, regresa
														al paso anterior.
													</Typography>
												</CardBody>
											</Card>
											<ShippingMethod
												costosEnvio={ListaCostosDeEnvio}
												paqueteriaSeleccionada={orderState.shipping}
												onSelect={(opcion) =>
													CambiarPaqueteria({
														target: { name: "Paqueteria", value: opcion },
													})
												}
												loading={loadingShippingMethods}
												error={errorCostosDeEnvio}
												formatPrice={CambiarFormatoPrecio}
												tieneDireccion={
													orderState.address !== null &&
													Object.keys(orderState.address).length > 0
												}
											/>
										</>
									)}
								</>
							) : (
								<Card className="carrito-card carrito-empty">
									<CardBody>
										<h5>No tienes productos en tu carrito</h5>
									</CardBody>
								</Card>
							)}
						</GridItem>

						<GridItem lg={4} md={12} sm={12} xs={12}>
							{orderState.items.length > 0 ? (
								<PurchaseSummary
									subtotal={orderState.totals.subtotal}
									envio={pasoActual === 2 ? orderState.totals.shipping : 0}
									total={orderState.totals.total}
									saldoAplicado={
										pasoActual === 2 ? orderState.totals.balanceApplied : 0
									}
									totalProductos={orderState.totals.itemCount}
									mensajesValidacion={mensajesValidacion}
									isValid={
										pasoActual === 1
											? orderState.selectedItems.length > 0 &&
											  orderState.address &&
											  Object.keys(orderState.address).length > 0
											: validarFormularioCompleto()
									}
									onConfirm={handleContinuar}
									formatPrice={CambiarFormatoPrecio}
									isProcessing={BotonComprar !== "Continuar"}
									buttonText={
										pasoActual === 1 ? "Continuar" : "Continuar con el pago"
									}
									mostrarEnvio={pasoActual === 2}
									descuentoCupon={orderState.totals.discount || 0}
									cupon={orderState.cupon}
									onAplicarCupon={aplicarCupon}
									onRemoverCupon={removerCupon}
									idUsuario={userState.id}
								/>
							) : null}
						</GridItem>
					</GridContainer>
					{VerModalDomicilio ? (
						<ModalDomicilio
							eventoModal={eventoModalDomicilio}
							verModal={VerModalDomicilio}
							domicilios={Domicilios}
							idCliente={userState.id}
						/>
					) : null}

					<Link to="/confirmar-compra">
						<Button id="ConfirmarCompra" color="transparent" />
					</Link>
					<ModalCargando Ver={false} Cuerpo={"Cargando"} />
					<Snackbar
						place="tc"
						color={colorNotificacion}
						message={mensaje}
						open={br}
						closeNotification={() => setBr(false)}
						close
					/>
				</div>
			</div>
		</div>
	);
};

export default withStyles(shoppingCartStyle)(ShoppingCartPage);
